import { render, staticRenderFns } from "./Detail-Contract.vue?vue&type=template&id=1b5b7451"
import script from "./Detail-Contract.vue?vue&type=script&lang=js"
export * from "./Detail-Contract.vue?vue&type=script&lang=js"
import style0 from "./Detail-Contract.vue?vue&type=style&index=0&id=1b5b7451&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports